import { Box, Button, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { calculateDateRange } from "../../redux/actions/action";
import IndividualCourseCard from "./IndividualCourseCard";

export default function AllCourses({ courses, filter }) {
  const [loadMoreVisible, setLoadMoreVisible] = useState(true);
  const [visibleData, setVisibleData] = useState([]);
  console.log(courses);

  useEffect(() => {
    setVisibleData(courses.slice(0, 12));
    if (courses.length <= 12) {
      setLoadMoreVisible(false);
    } else {
      setLoadMoreVisible(true);
    }
  }, [courses]);

  const loadMoreHandler = () => {
    setVisibleData(courses.slice(0, visibleData.length + 12));
    if (visibleData.length + 12 >= courses.length) {
      setLoadMoreVisible(false);
    }
  };

  return (
    <Box
      w="100%"
      d="flex"
      flexWrap={["nowrap", "nowrap", "wrap", "wrap"]}
      flexDir={["column", "column", "row", "row"]}
      justifyContent="flex-start"
      alignItems="center"
      style={{ gap: "2.25rem" }}
    >
      {visibleData.length > 0 ? (
        visibleData.map((course) => (
          <IndividualCourseCard
            id={course.id}
            key={course.id}
            title={course.title}
            image={course.cover_image}
            favourite = {course.favourite}
            date={calculateDateRange(course.start_date, course.end_date)}
            level = {course.level}
            certificate={
              course.certificate_option
                ? course.certificate_option.toUpperCase() === "Y"
                : "false"
            }
          />
        ))
      ) : (
        <Text
          fontSize={["15px", "15px", "20px", "25px"]}
          fontWeight="700"
          style={{ fontFamily: "Mulish, sans-serif" }}
        >
            No {filter} Courses to display!
        </Text>
      )}
      <Box width="100%" d="flex" justifyContent="center" alignItems="center">
        {loadMoreVisible && (
          <Button
            color="#00000099"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize={["12px", "14px", "16px", "18px"]}
            border="2px solid rgba(0, 0, 0, 0.1)"
            boxShadow="0px 3px 16px rgba(0, 0, 0, 0.1)"
            borderRadius="xl"
            py={["0.5rem", "0.75rem", "1rem", "1.5rem"]}
            px={["0.75rem", "1rem", "1.5rem", "2rem"]}
            m="2rem"
            bg="#ffffff"
            onClick={loadMoreHandler}
          >
            Load More...
          </Button>
        )}
      </Box>
    </Box>
  );
}
